import React, { Component, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

const PassTerm = () => {

  return(
    <React.Fragment>
      <div className="content">
          <div className="inner">
            <h4 className="tit-lev0">비밀번호 변경</h4>
            <div className="login">
                <div className="login-wrap">
                    <div className="login-title">
                        <h5><em>김길동</em>님은 3개월 이상 비밀번호를 변경하지 않으셨습니다</h5>
                        <p className="info">개인정보를 보호하고, 정보도용으로 인한 피해를 예방하기 위해 정기적으로 비밀번호를 변경해주세요.</p>
                    </div>
                    <div className="login-body">
                        <div className="login-content">
                            <div className="term-infor">
                                <h4 className="sub-title">기존 비밀번호를 입력하세요.</h4>
                                <div className="line-Box">
                                    <label className="input-title" htmlFor="pw1">기존 비밀번호 변경</label>
                                    <input id="pw1" type="text" name="" placeholder="기존비밀번호를 입력해주세요" className="form-control input-text" />
                                </div>
                                <h4 className="sub-title m-t-20">새로운 비밀번호를 입력해주세요.</h4>
                                <div className="line-Box">
                                    <div>
                                        <label className="input-title" htmlFor="pw2">새 비밀번호</label>
                                        <input id="pw2" type="text" name="" placeholder="영문, 숫자, 특수문자 중 2종류를 조합 10~16자 (3종류 8~16자리)" className="form-control input-text"  />
                                    </div>
                                    <div className="m-t-10">
                                        <label className="input-title" htmlFor="pw3">비밀번호 확인</label>
                                        <input id="pw3" type="text" name="" placeholder="비밀번호를 한번 더 입력하세요." className="form-control input-text"  />
                                    </div>
                                </div>
                                <div className="m-t-20">
                                    <input id="isSaveId" type="checkbox" className="checkbox small" />
                                    <label htmlFor="isSaveId">일주일 뒤에 변경하기</label>
                                </div>
                            </div>

                            <div className="btn-box text-center m-t-20">
                                <button className="btn btn-blue btn-lg " >
                                    비밀번호변경
                                </button>
                                <button className="btn btn-white btn-lg " >
                                    다음에 변경
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </div>
    </React.Fragment>
  )
}

export default PassTerm

